import { ValidationList } from '@qbe/ads-blocks-forms';
import { Box, Spacer, Stack, Typography } from '@qbe/ads-core';
import React from 'react';

import { imgMap } from '~/components-ds/Icon/Icon';
import { InformationListType } from '~/types/interfaces';

interface InformationListProps {
  list: InformationListType[];
  footerText?: string;
}

const InformationList: React.FC<InformationListProps> = ({ list, footerText }) => (
  <>
    <Stack
      sx={{
        marginBottom: footerText?.length && 4,
        // TODO - remove minWidth: https://qbe-appservices.atlassian.net/browse/AD1-448
        minWidth: { xs: '260px', md: '400px' },
      }}
    >
      {list.map((item) => (
        <Box
          key={item.id}
          textAlign="left"
          sx={{
            '& .ads-form-block.ValidationList': {
              padding: '12px 0 12px 0 !important',
            },
          }}
        >
          <Typography variant="h5" component="h2" color="text.primary">
            {item.header}
          </Typography>

          {item.sections.map((section, idx1, arr) => (
            <Box key={idx1}>
              <ValidationList
                // TODO - use ADS Icon
                icon={<img src={imgMap.home} width="17px" height="19px" alt="icon" />}
                list={[
                  {
                    id: idx1,
                    item: section.subHeader,
                  },
                ]}
                sx={{
                  '*': {
                    fontWeight: 'fontWeightBold',
                  },
                }}
              />

              <ValidationList
                // TODO - use ADS Icon
                icon={<img src={imgMap.excessCasuality} width="17px" height="19px" alt="icon" />}
                list={section.infoList.map((i) => ({
                  id: i,
                  item: i,
                }))}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Stack>
    {footerText && <Typography variant="body2">{footerText}</Typography>}
  </>
);

export default InformationList;
